import { useEffect } from 'react';
import toast from 'react-hot-toast';
import { INTERACTIVE_LOGIN_COMPLETE } from '@/shared/auth/authEvents';
import NotificationService from '@/shared/services/NotificationService';
import { pluralNotifications, pluralUnread } from '@/shared/utils/pluralUtils';

const LOGIN_TOAST_STYLE = {
  background: '#243964f3',
  color: '#fff',
  padding: '16px 24px',
  borderRadius: '8px',
  fontSize: '16px',
  fontWeight: '500',
  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
  maxWidth: '500px',
  minWidth: '300px',
};

const UNREAD_TOAST_STYLE = {
  ...LOGIN_TOAST_STYLE,
  borderLeft: '5px solid #efb036',
};

function unreadNotificationsCopy(count) {
  if (count === 1) return 'Имате једно непрочитано обавештење.';
  return `Имате ${count} ${pluralUnread(count)} ${pluralNotifications(count)}.`;
}

function showInteractiveLoginFeedback() {
  toast.success('Успешно сте се пријавили', {
    duration: 4000,
    position: 'bottom-center',
    style: LOGIN_TOAST_STYLE,
    iconTheme: { primary: '#fff', secondary: '#243964f3' },
  });

  window.setTimeout(() => {
    NotificationService.search(false, { forceRefresh: true })
      .then((data) => {
        const count = Array.isArray(data) ? data.length : 0;
        if (count <= 0) return;

        toast.success(unreadNotificationsCopy(count), {
          duration: 6500,
          position: 'bottom-center',
          style: UNREAD_TOAST_STYLE,
          icon: '🔔',
        });
      })
      .catch(() => {});
  }, 550);
}

/**
 * Posle interaktivne prijave (`ogp:interactive-login-complete`): toast dobrodošlice,
 * zatim kratko odloženo obaveštenje sa brojem nepročitanih (ako je broj > 0).
 * Događaj emituje `useAuthRedirect` posle OIDC callback-a; silent renew ga ne šalje.
 * @returns {void}
 */
export function useJustLoggedInFeedback() {
  useEffect(() => {
    sessionStorage.removeItem('justLoggedIn');

    const onInteractiveLoginComplete = () => {
      showInteractiveLoginFeedback();
    };

    window.addEventListener(INTERACTIVE_LOGIN_COMPLETE, onInteractiveLoginComplete);
    return () => {
      window.removeEventListener(INTERACTIVE_LOGIN_COMPLETE, onInteractiveLoginComplete);
    };
  }, []);
}
